export interface AuthRefreshTokenPayload {
  accessToken: string;
  accessTokenExpiry: Date; // or TTL
  refreshToken: string;
  refreshTokenExpiry: Date; // or TTL
}

export interface AuthRefreshToken extends AuthRefreshTokenPayload {}

export class AuthRefreshToken {
  constructor(payload: AuthRefreshTokenPayload) {
    Object.assign(this, payload);
  }

  isAccessTokenExpire(): boolean {
    return this.accessTokenExpiry.getTime() < Date.now();
  }

  isRefreshTokenExpire(): boolean {
    return this.refreshTokenExpiry.getTime() < Date.now();
  }

  isValid() {
    return !this.isRefreshTokenExpire();
  }
}
